<template>
    <div>
        <div class="create-first-helm">
            <div class="title-col2 text-center">
                <h4 class="md-title">Create your first HELM charts repository</h4>
                <p class="text-black">You need a repository to upload your helm charts</p>
            </div>
            <div class="btnCol text-center">
                <inertia-link :href="route('teams.create')" as="button" class="btn btn-style btn-secondary">
                    <i class="demo-icon icon-union2 lg-icon"></i>
                    <span>CREATE REPOSITORY</span>
                </inertia-link>
            </div>
            <div class="first-helm-img text-center">
                <img src="admin_stylesheet/images/first-helm.svg" alt="...">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },

        methods: {}
    }
</script>
